import { render } from "./PerfilView.vue?vue&type=template&id=5d12762a&scoped=true"
import script from "./PerfilView.vue?vue&type=script&lang=js"
export * from "./PerfilView.vue?vue&type=script&lang=js"

import "./PerfilView.vue?vue&type=style&index=0&id=5d12762a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d12762a"]])

export default __exports__